import { Component, EventEmitter, Input, Output } from '@angular/core';
import { EnumItem } from '@core/models/enum-item.model';

@Component({
  selector: 'pop-radio-button-group',
  templateUrl: './radio-button-group.component.html',
  styleUrls: ['./radio-button-group.component.less']
})
export class RadioButtonGroupComponent<T> {
  private static counter = 0;

  @Input()
  public name = `radio${RadioButtonGroupComponent.counter++}`;

  @Input()
  public options?: EnumItem<T>[];

  @Input()
  public disabled = false;

  private _selectedOption: EnumItem<T> | undefined;
  public get selectedOption() {
    return this._selectedOption.key;
  }
  @Input() public set selectedOption(value: T | undefined) {
    this._selectedOption = this.options.find(o => o.key === value);
  }

  public changeSelectedOption(value: T | undefined) {
    this.selectedOption = value;
    this.selectedOptionChange.emit(value);
  }

  @Output() public selectedOptionChange = new EventEmitter<T | undefined>();
}
